(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports.host = "rosterup.kmdg";
},{}],2:[function(require,module,exports){
var project = require('../../settings');
var utils = require('./modules/utils');

/* Event Handlers  */
(function ($, $PB) {

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        utils.equalHeight('.equal');
        $(window).trigger('resize').trigger('scroll');
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": mmtitle,
            },
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        }
    );

    /*$("#menu-wrapper").mmenu({
        "navbar": {
            "title": mmtitle,
        },
        "extensions": [
            "pagedim-black",
            "theme-dark",
            "position-right"
        ],
        classNames: {
            fixedElements: {
                fixed: "fix",
                sticky: "stick"
            }
        }
    });*/

    $( document ).ready(function() {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    $('.builder-layout-half-block .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.builder-layout-rollover-section .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.tabs-container ul.tabs-wrap li:first-child').addClass('open');
    $('.tab-outer-wrap .tab-content:first-child').addClass('open');

    $('.tabs-container ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.tabs-container ul.tabs-wrap li').removeClass('open');
        $('.tab-content').removeClass('open');

        $(this).addClass('open');
        $("#"+$tab_id).addClass('open');

    });

    $('.deletePlayer').on('click', function () {
        var $me = $(this);

        $.ajax(ajaxurl, {
            method: "POST",
            dataType: "json",
            data: {
                'uid': $(this).attr('data-id'),
                'action': "rosterup-delete-player"
            },
            beforeSend: function() {
                window.roserupAJAXrunning = confirm("Are you sure you wish to delete this player?");
                return window.roserupAJAXrunning;
            }
        }).done(function(response) {
            console.log(response);
            if(response.data.success) {
                $me.parents('.player-mobile').remove();
                $me.parents('tr').remove();
                alert("Player Deleted!");
            } else {
                alert(response.data.errorMsg);
            }
        }).fail(function() {
            if(window.roserupAJAXrunning) {
                alert("Error: Unable to delete player. Please make sure you are still logged in.")
                window.location.reload(true);
            }
        });
    });

    $('#payment-options').on('change', function() {
        setTimeout(function() {
            $('#_sumo_pp_payment_type_fields > p').hide();
            $('#_sumo_pp_payment_type_fields p input:first').removeAttr('checked');
            $('#_sumo_pp_payment_type_fields p input:last').attr('checked', 'checked');
            $('#_sumo_pp_plans_to_choose').show();
        }, 10);
    });

})(jQuery, KMDGPB.jQuery);
},{"../../settings":1,"./modules/utils":3}],3:[function(require,module,exports){
/* Utility functions */

/**
 * Equalizes the height of a given group of elements, making them all
 * at least as big as the largest of the group (but not restricting future
 * expansion. You may optionally pass in a parent selector by which the
 * elements will be equalized (each instance of the group selector will be
 * given equal heights within thier parent, rather than across all elements
 * matching that selector globally).
 * @param string group
 * @param string parent
 */
var equalHeight = function (group, parent) {
    parent = parent || "body";
    jQuery(parent).each(function () {
        tallest = 0;
        jQuery(this).find(group).each(function () {
            var $this = jQuery(this);

            thisHeight = $this.height();
            if ($this.css('box-sizing') === 'content-box') {
                if (thisHeight > tallest) {
                    tallest = thisHeight;
                }
            } else {
                thisPadding = Number($this.css('padding-top').replace('px', ''))
                    + Number($this.css('padding-bottom').replace('px', ''));

                if ((thisHeight + thisPadding) > tallest) {
                    tallest = thisHeight + thisPadding;
                }
            }
        });
        jQuery(this).find(group).css('min-height', tallest);
    });
};

var trim = function (x) {
    return x.replace(/^\s+|\s+$/gm, '');
}

exports.equalHeight = equalHeight;
exports.trim = trim;

},{}]},{},[2]);
